import { AddPartsCategory } from 'modals';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CommonModal, CustomPagination } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { deleteVehicleGroupData, getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import AddEditVehicleDocTypeModel from 'modals/AddEditVehicleDocTypeModel/AddEditVehicleDocTypeModel';
import { deleteVehicleDocData, getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import { CiLock, CiUnlock } from 'react-icons/ci';
import { deleteCategory, deleteStore, getPartCategoryList, getStoreList } from '_services/workShopServices/workShopServices';
import AddEditStoreModel from 'modals/AddEditStoreModel';

const WorkshopPurchaseParts = () => {

  useDocumentTitle("Workshop Parts | T360");
  const [showAddPartsCategory, setShowPartsCategory] = useState(false);

  const { settingChild } = useContext(UserContext);
  const settingChildVehicleGrp = settingChild?.find((i) => i?.label === "Vehicle Group");
  const [storeModelData, setStoreModelData] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [storeDataList, setStoreDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const prevFilterRef = useRef();
  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    // status: 1
  });

  const toggleStoreModelData = () => {
    setStoreModelData(!storeModelData);
  };

  const getDataStoreList = async () => {
    try {
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
      }
      const res = await getPartCategoryList(object);
      if (res?.responseCode == 200) {
        setStoreDataList(res?.data?.partData);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      // throw error;
    }
  }

  useEffect(() => {
    const prevFilter = prevFilterRef.current;
    if (
      JSON.stringify(prevFilter) !== JSON.stringify(filter)
    ) {
      getDataStoreList();
      prevFilterRef.current = filter;
    }
  }, [filter, storeModelData])

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteStore = async (itemData) => {
    setLoading(true);
    try {
      let object = {}
      if (itemData?.disable) {
        object['id'] = itemData?._id;
        object['status'] = (itemData?.status === 1) ? 3 : 1;
      } else {
        object['id'] = isDelete?._id;
        object['status'] = 2;
      }
      const res = await deleteCategory(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataStoreList();
        setLoading(false);
        setIsDelete(false);
      } else {
        if (res?.responseMessage) {
          toast.error(res?.responseMessage);
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteStore,
    isLoadding: loading,
  }

  let storeModelProps = {
    isOpen: storeModelData,
    closeModal: (e) => setStoreModelData(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: storeModelData?.isDetails ? "View Store" : (storeModelData?._id ? 'Update Store' : 'Add Store'),
    submitTitle: storeModelData?.isDetails ? "View Store" : (storeModelData?._id ? 'Update Store' : 'Add Store'),
    footerPart: storeModelData?.isDetails ? true : false,
    hideFooterSumbmitBtn: storeModelData?.isDetails ? true : false,
    hideCompletelyFoolter: storeModelData?.isDetails ? true : false,
    ApiCall: getDataStoreList
  }

  const columns = [
    { header: "Parts Category Name", accessor: "category_name" },
    { header: "Part Type", accessor: "part_type" },
    { header: "Manage Inventory", accessor: "manage_inventory" },
    { header: "Measurement Unit", accessor: "measurement_unit" },
    { header: "Status", accessor: "status" },
    { header: "Action", accessor: "action" }
  ];

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      category_name: <span className='_tblText _style_ancer' onClick={(e) => setShowPartsCategory({ ...item, isDetails: true })}>
        <a className='_avPointer'>
          {item?.name ? item?.name : '-'} &nbsp;
        </a>
      </span>,
      part_type: <>{item?.part_type ? 'Multiple Type' : 'Single Type'}</>,
      manage_inventory: <>{item?.inventory === 1 ? 'Yes' : 'No'}</>,
      measurement_unit: <>{item?.unit?.name ? item?.unit?.name : '-'}</>,
      status: <div style={{ color: (item?.status === 1) ? "green" : "red" }}>{item?.status ? constant.ActionStore.find((el) => el?.value === item?.status)?.label : '-'}</div>,
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          <div
            onClick={(e) => setShowPartsCategory(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='editIcon_avt'>
                <FiEdit color='blue' />
              </span>
            </span>
            {/* Edit */}
          </div>

          <div
            onClick={(e) => deleteHandler(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='deleteIcon_avt'>
                <FaRegTrashCan color='red' />
              </span>
            </span>
            {/* Delete */}
          </div>

          <div
            onClick={(e) => submitDeleteStore({ ...item, disable: true })}
            className='_avPointer'
          >
            {/* <span className='_samAnchor'>
              <span className='editIcon_avt'>
                <FiEdit color='blue' />
              </span>
            </span> */}
            {item?.status === 1 ? <CiUnlock color="green" size={20} /> : <CiLock color="red" size={20} />}
            {/* {item?.status === 1 ? 'Disable' : 'Enable'} */}
          </div>
        </div>
      ),
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  let addPartsCategoryModalProps = {
    isOpen: showAddPartsCategory,
    closeModal: (e) => setShowPartsCategory(false),
    modalMainClass: " _dashCommon_Modal _addExpModal",
    modalTitle: showAddPartsCategory?.isDetails ? 'View Category' : (showAddPartsCategory?._id ? "Update Category" : "Add Category"),
    hideFooterSumbmitBtn: showAddPartsCategory?.isDetails ? true : false,
    hideCompletelyFoolter: showAddPartsCategory?.isDetails ? true : false,
    footerPart: true,
    submitTitle: "Save",
    callListApi: () => getDataStoreList(),
  };

  return (
    <>
      <div className=''>
        <ButtonHeading
          title="Category"
          onClick={() => setShowPartsCategory(!showAddPartsCategory)}
          buttonTitle={"Add Category"}
          showSearchFilter={{ search: true, filterOption: false, filterCount: true }}
          onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
          filter={filter}
          setFilter={setFilter}
          isDebouncedSearch={true}
        />
      </div>

      <div className='_tabWith_outTab'>
        <BootstrapTable
          columns={columns}
          data={rowListData(storeDataList?.length > 0 ? storeDataList : [])}
          // isLoading={loading}
        />

        {storeDataList?.length ? <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div> : <></>}
      </div>

      {
        isDelete?._id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
          </CommonModal>
        )
      }

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
      >
        {showFilterModal &&
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        }
      </div>
      <div className={showFilterModal ? 'offBack_drop' : ''}></div>

      {showAddPartsCategory && <AddPartsCategory {...addPartsCategoryModalProps} />}
    </>
  )
}

export default WorkshopPurchaseParts